import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';
import { SeedingApplyAcceptBodySchema } from './seedingMutationSchemas';

const AcceptSeedingProposalRequestSchema = z
  .object({
    participationId: z.number().int(),
    body: SeedingApplyAcceptBodySchema,
  })
  .describe('AcceptSeedingProposalRequest');

export type AcceptSeedingProposalRequest = z.infer<typeof AcceptSeedingProposalRequestSchema>;

const AcceptSeedingProposalResponseDataSchema = z
  .object({
    orderNo: z.string(),
    orderOptionIds: z.array(z.number().int()),
    fulfillmentIds: z.array(z.number().int()),
  })
  .describe('AcceptSeedingProposalResponseData');

const AcceptSeedingProposalResponseSchema = createApiResponseSchema(
  AcceptSeedingProposalResponseDataSchema,
);

export type AcceptSeedingProposalResponse = z.infer<typeof AcceptSeedingProposalResponseSchema>;

export const acceptSeedingProposal = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(AcceptSeedingProposalRequestSchema),
    async ({
      participationId,
      body,
    }: AcceptSeedingProposalRequest): Promise<AcceptSeedingProposalResponse> =>
      executeStandardRequest(async () =>
        privateHttpClient.post<AcceptSeedingProposalResponse>(
          urlJoin(campaignsApiPath.acceptSeedingProposal(participationId)),
          body,
        ),
      ),
    validateApiResponse(AcceptSeedingProposalResponseSchema),
  ),
);
